export default __webpack_public_path__ + "48eb31468b293d34dfa569d9764f62b4.svg";